import Button from '@components/_Revamp/Button';
import { styled } from '@linaria/react';
import React from 'react';
import { themeDefault } from 'src/theme-revamp';



export interface AnswerButtonGropuProps {
  values?: string;
  onPickaAnswer: (answer: string) => void;
}

export const AnswerButtonGroup = ({
  values,
  onPickaAnswer,
}: AnswerButtonGropuProps) => {
  const btnYes_Clicked = () => {
    onPickaAnswer('Y');
  };
  const btnNo_Clicked = () => {
    onPickaAnswer('N');
  };


  return (
    <ButtonGroupContainer>
      <Button
        theme={themeDefault}
        label="Yes"
        variant={values === 'Y' ? 'default' : 'light'}
        width="281px"
        height="54px"
        onClick={btnYes_Clicked}
      />
      <Button
        theme={themeDefault}
        label="No"
        variant={values === 'N' ? 'default' : 'light'}
        width="281px"
        height="54px"
        onClick={btnNo_Clicked}
      />
    </ButtonGroupContainer>
  );
};

const ButtonGroupContainer = styled.div`
  display:flex;
  width:100%;
  align-items:center;
  flex-direction:column;
  row-gap:20px;
  @media screen and (min-width: 768px) {
    flex-direction:row;
    column-gap:24px;
  }


`;